import { http } from '@/api/client/httpClient';
import { downloadQuery } from '@/api/client/download';
import type {
  DailyReconcileResultDto,
  ReconciliationBufferAmountsDto,
  ReconciliationInputDto,
  ReconciliationType,
  SaveBufferAmountInputDto,
} from '@/api/types/reconciliation';

// ABP route derivation (concrete AppService namespace ...Reconciliation.ReconciliationAppService):
//   Reconcile(ReconciliationInputDto)              -> POST /reconcile (body)
//   GetBufferAmounts(ReconciliationType)           -> GET  /buffer-amounts (query)
//   SaveBufferAmount(SaveBufferAmountInputDto)     -> POST /save-buffer-amount (body)
//   GetDailyReconciliationExcel(ReconciliationInputDto) -> GET /daily-reconciliation-excel (query, blob)
//   GetDailyReconciliationPdf(ReconciliationInputDto)   -> GET /daily-reconciliation-pdf (query, blob)
// `Get` is stripped from Get-prefixed actions; their complex DTO binds from the
// query string (verb GET). Non-Get methods with a complex DTO map to POST + body.
const R = '/api/app/reconciliation';

export const reconciliationApi = {
  reconcile: (input: ReconciliationInputDto) =>
    http.post<DailyReconcileResultDto>(`${R}/reconcile`, input).then((r) => r.data),

  getBufferAmounts: (reconciliationType: ReconciliationType) =>
    http
      .get<ReconciliationBufferAmountsDto>(`${R}/buffer-amounts`, { params: { reconciliationType } })
      .then((r) => r.data),

  saveBufferAmount: (input: SaveBufferAmountInputDto) =>
    http.post<void>(`${R}/save-buffer-amount`, input).then((r) => r.data),

  downloadExcel: (input: ReconciliationInputDto, fallback: string) =>
    downloadQuery(`${R}/daily-reconciliation-excel`, { date: input.date, isLive: input.isLive }, fallback),

  downloadPdf: (input: ReconciliationInputDto, fallback: string) =>
    downloadQuery(`${R}/daily-reconciliation-pdf`, { date: input.date, isLive: input.isLive }, fallback),
};
